import React, { Component } from 'react';
import AuthService from '../../utils/AuthService';
import Page from '../Page';
import PageSection from '../PageSection';
import Table from '../Table';
import Input from '../Input';
import Select from '../Select';
import BMYForm from '../BMYForm';

var Auth = new AuthService();

class ManageBoats extends Component {
	constructor(props) {
		super(props);

		var path = props.path;

		var initialBuilderInfo = {
			selectedId: null,
			selectedText: ""
		};
		
		var initialModelInfo = {
			selectedId: null,
			selectedText: ""
		};		

		this.setLetter = this.setLetter.bind(this);
		this.getBMYs = this.getBMYs.bind(this);
		this.handleFilterInputChange = this.handleFilterInputChange.bind(this);
		this.handleFilterSelectChange = this.handleFilterSelectChange.bind(this);
		this.setBMY = this.setBMY.bind(this);
		this.changeBuilder = this.changeBuilder.bind(this);
		this.changeModel = this.changeModel.bind(this);
		this.changeYear = this.changeYear.bind(this);

		this.state = {
			bmyInfo: {},
			builderInfo: initialBuilderInfo,
			modelInfo: initialModelInfo,
			year: "",
			loadingText: <p className="pp-loading">Loading Boats</p>,
			tableHeader: ['Builder', 'Model', 'Year', 'LWL', 'BWL', 'Displacement', ''],
			tableBody: [],
			letter: 'a',
			lwlMin: '',
			lwlMax: '',
			bwlMin: '',
			bwlMax: '',
			disMin: '',
			disMax: '',
			subApplication: '',
			applications: []
		};

		this.pageActions = <a href="/create-boat" className="pp-plus-button">Create Boat</a>
		this.pageTitle = 'Manage Boats';
		this.boatAction = 'edit';
		this.boatURL = '/manage-boats/';

		if (path == '/view-boats') {
			this.pageTitle = 'View All Boats';
			this.boatAction = 'view';
			this.pageActions = '';
			this.boatURL = '/view-boats/';
		}

		this.getBMYs();
	}

	componentDidMount() {
		// get applications
		this.Auth.fetch("/boat-applications")
		.then(
			(result) => {
				if(result) {
					this.setState({
						applications: result.data,
						subApplications: result.boat_sub_applications
					});
				} else {
					if(result.errors) {
						alert(result.errors.join("\n"));
					}
				}
			},
			(error) => {
				this.setState({
					error
				});
			}
		);
	}

	getBMYs() {
		this.Auth = new AuthService();
		let user = this.Auth.getProfile(),
			userRole = user.pp_role_id,
			letter = this.state.letter,
			modelID = this.state.modelInfo.selectedId ? '&modelID=' + this.state.modelInfo.selectedId : '',
			modelText = this.state.modelInfo.selectedText ? '&modelText=' + this.state.modelInfo.selectedText : '',
			boatYear = this.state.year ? '&boatYear=' + this.state.year : '';
	
		this.Auth.fetch('/bmy?letter=' + letter + 
		'&lwlMin=' + this.state.lwlMin +
		'&lwlMax=' + this.state.lwlMax +
		'&bwlMin=' + this.state.bwlMin +
		'&bwlMax=' + this.state.bwlMax +
		'&disMin=' + this.state.disMin +
		'&disMax=' + this.state.disMax +
		'&builderID=' + this.state.builderInfo.selectedId +
		modelID +
		modelText +
		boatYear +
		'&bmyID=' + this.state.bmyInfo.bmy_id +
		'&subApplication=' + this.state.subApplication
		)
			.then((result) => {
				console.log(result);
				var row = [],
					body = [];

				if (result.success === true) {
					for (let a = 0; a < result.bmy.length; a += 1) {
						// filter out BMYs that were added from the seatrial app for non admin users
						// BMYs added from the seatrial app will not have an LWL value
						if (userRole != 1 && result.bmy[a].lwl == null) {
							continue;
						}
						row = [];
						row.push(result.bmy[a].builder_name);
						row.push(result.bmy[a].model_name);
						row.push(result.bmy[a].boat_year);
						row.push(parseFloat(result.bmy[a].lwl).toFixed(2));
						row.push(parseFloat(result.bmy[a].bwl).toFixed(2));
						row.push(parseFloat(result.bmy[a].displacement).toFixed(2));
						// row.push(result.bmy[a].published_reports);
						row.push(<a href={this.boatURL + result.bmy[a].bmy_id}>{this.boatAction}</a>);
						body.push(row);
					}

					if (body.length == 0) {
						this.setState({
							loadingText: <div>No Boats Found</div>
						});
					}

					this.setState({
						tableBody: body
					});

				} else {
					alert(result.message);
				}
			});
	}

	setLetter(letter) {
		if (letter == this.state.letter) {
			letter = '';
		}

		this.setState({
			letter: letter,
			tableBody: [],
			loadingText: <p className="pp-loading">Loading Boats</p>
		});

		// unholy code
		var that = this;
		setTimeout(function(){
			that.getBMYs();
		}, 100);
	}

	handleFilterInputChange(event) {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value,
			tableBody: [],
			loadingText: <p className="pp-loading">Loading Boats</p>
		});

		// unholy code
		var that = this;
		setTimeout(function(){
			that.getBMYs();
		}, 100);
	}

	handleFilterSelectChange(event) {
		const target = event.target;
		const value = target.value;
		const name = target.name;

		this.setState({
			[name]: value,
			tableBody: [],
			loadingText: <p className="pp-loading">Loading Boats</p>
		});

		// unholy code
		var that = this;
		setTimeout(function(){
			that.getBMYs();
		}, 100);
	}

	setBMY(bmy) {
		this.setState({
			bmyInfo: bmy
		});
	}

	changeBuilder(builderInfo) {
		let letter = '';

		if (builderInfo.selectedId == null) {
			letter = 'a';
		}

		if (this.state.builderInfo.selectedId != builderInfo.selectedId) {
			this.setState({
				builderInfo,
				tableBody: [],
				loadingText: <p className="pp-loading">Loading Boats</p>,
				letter: letter
			});

			// unholy code
			var that = this;
			setTimeout(function(){
				that.getBMYs();
			}, 100);
		} else {
			this.setState({
				builderInfo
			});
		}
	}

	changeModel(modelInfo) {
		if (this.state.modelInfo.selectedId != modelInfo.selectedId || this.state.modelInfo.selectedText != modelInfo.selectedText) {
			this.setState({
				modelInfo,
				tableBody: [],
				loadingText: <p className="pp-loading">Loading Boats</p>
			});

			// unholy code
			var that = this;
			setTimeout(function(){
				let letter = '';

				if (that.state.modelInfo.selectedText == "" && that.state.modelInfo.selectedId == null) {
					letter = 'a';
				}

				that.setState({
					letter: letter
				});

				setTimeout(function(){
					that.getBMYs();
				}, 100);
			}, 100);
		} else {
			this.setState({
				modelInfo
			});
		}
	}

	changeYear(year) {
		var digit = /^[0-9]+$/;
		var that = this;

		setTimeout(function(){
			that.getBMYs();
		}, 100);

		this.setState({
			year
		});
	}

	render() {
		const { 
			bmyInfo,
			builderInfo,
			modelInfo,
			year,
			disableBMY } = this.state;

		let loadingText = this.state.loadingText,
			pages = [];

			if ( this.state.letter == '!' ) {
				pages.push( <div className="letter selected" onClick={()=>{ this.setLetter('!') }}>#</div> );
			} else {
				pages.push( <div className="letter" onClick={()=>{ this.setLetter('!') }}>#</div> );
			}

		for (let a = 97; a < 123; a++ ) {
			if (String.fromCharCode(a) == this.state.letter) {
				pages.push( <div className="letter selected" onClick={()=>{ this.setLetter(String.fromCharCode(a)) }}>{String.fromCharCode(a)}</div> );
			} else {
				pages.push( <div className="letter" onClick={()=>{ this.setLetter(String.fromCharCode(a)) }}>{String.fromCharCode(a)}</div> );
			}
		}

		const { applications } = this.state;
		console.log('a', applications);

		// convert lists to option lists for select element
		let applicationOptions = [];
		let subApplications = [];
		for(let i=0; i < applications.length; i++) {
			applicationOptions.push({
				value: applications[i].boat_app_id,
				text: applications[i].boat_application_name
			});
		}

		if (applications.length > 0) {
			subApplications = [...applications[0].sub_applications, ...applications[1].sub_applications, ...applications[2].sub_applications];
		}

		let subApplicationOptions = [];
		let dups = [];
		for(let i=0; i < subApplications.length; i++) {
			if (dups.indexOf(subApplications[i].sub_application_name) == -1) {
				subApplicationOptions.push({
					value: subApplications[i].sub_application_name,
					text: subApplications[i].sub_application_name
				});
				dups.push(subApplications[i].sub_application_name);
			}
		}

		subApplicationOptions.sort((a, b) => 
			a.text.localeCompare(b.text)
		);

		return (
			<Page
				pageTitle={this.pageTitle}
				pageClass="pp-manage-boats-page"
				pageActions={this.pageActions}
			>

				<div className="filters">

					<div className="bmy-filter">
						<p className="label">Filter by Boat</p>
						<BMYForm
							setBMY={this.setBMY}
							bmyInfo={bmyInfo}
							changeBuilder={this.changeBuilder}
							changeModel={this.changeModel}
							changeYear={this.changeYear}
							builderInfo={builderInfo}
							modelInfo={modelInfo}
							year={year}
							disableAll={disableBMY}
							enableModelOverride={true}
							enableYearOverride={true}
							error={false}
						/>
					</div>

					<div className="range-filter">
						<div className="filter">
							<p className="label">LWL</p>
							<Input
								type="text"
								htmlName="lwlMin"
								label=""
								placeholderText="Min"
								onChange={this.handleFilterInputChange}
								value={this.state.lwlMin}
							/>
							<Input
								type="text"
								htmlName="lwlMax"
								label=""
								placeholderText="Max"
								onChange={this.handleFilterInputChange}
								value={this.state.lwlMax}
							/>
						</div>
						<div className="filter">
							<p className="label">BWL</p>
							<Input
								type="text"
								htmlName="bwlMin"
								label=""
								placeholderText="Min"
								onChange={this.handleFilterInputChange}
								value={this.state.bwlMin}
							/>
							<Input
								type="text"
								htmlName="bwlMax"
								label=""
								placeholderText="Max"
								onChange={this.handleFilterInputChange}
								value={this.state.bwlMax}
							/>
						</div>
						<div className="filter">
							<p className="label">Displacement</p>
							<Input
								type="text"
								htmlName="disMin"
								label=""
								placeholderText="Min"
								onChange={this.handleFilterInputChange}
								value={this.state.disMin}
							/>
							<Input
								type="text"
								htmlName="disMax"
								label=""
								placeholderText="Max"
								onChange={this.handleFilterInputChange}
								value={this.state.disMax}
							/>
						</div>

						<div className="filter">
							<p className="label">Sub Application</p>
							<Select
								type="text"
								htmlID="sub-application"
								htmlName="subApplication"
								placeholderText="Sub-Application"
								value={this.state.subApplication}
								onChange={this.handleFilterSelectChange}
								options={subApplicationOptions}
							/>
						</div>

					</div>

					<div className="letter-pagination">
						{pages}
					</div>
				</div>

				<PageSection>
					<Table
						tableHeading={this.state.tableHeader}
						tableBody={this.state.tableBody}
						noResultsMessage={loadingText}
					/>
				</PageSection>

				<div className="letter-pagination">
					{pages}
				</div>
			</Page>
		);
	}
}

export default ManageBoats;



// WEBPACK FOOTER //
// ./src/components/pages/ManageBoats.js